<dynamic-form
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [isSaved]="isSaved"
  [saveLabel]="'ClientApp.FrontOffice.Financial.AccountingDocument.Save' | translate"
  secondClass="main-page"
  [isShowModal]="false">
  <ng-container class="content">
    <div
      class="form-header"
      [contextMenuTrigger]="menu"
      [menuContext]="{ value: accountingDocumentSetting, visible: formMenuContextVisible, settingChanges$: settingChanges$ }"
      (menuAction)="($event)">
      <date-picker
        name="StartDate"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.StartDate' | translate"
        textType="date"
        [disabled]="false">
      </date-picker>
      <date-picker
        name="EndDate"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.EndDate' | translate"
        textType="date"
        [disabled]="false">
      </date-picker>
      <ssg-select
        *ngIf="this.BranchLookUp && this.BranchLookUp?.length > 0"
        name="BranchId"
        [group]="formGroup"
        [dataList]="BranchLookUp"
        [label]="'ClientApp.FrontOffice.Financial.AccountingDocument.Branch' | translate"
        textFieldName="Title"
        valueFieldName="Id"
        userClass="select-sm">
      </ssg-select>
      <ssg-button
        [label]="'ClientApp.FrontOffice.Financial.AccountingDocument.UploadInformation' | translate"
        class="action-btn"
        (click)="GetList()"></ssg-button>
      <ng-container *ngIf="currentInformation.TreasuryKind === SoftWareLicenseKind.TreasuryWeb">
        <div class="detail-info" *ngIf="(sumDebit || sumCredit) && showAccountingDocument">
          <span>{{ "ClientApp.FrontOffice.Financial.AccountingDocument.TotalDebt" | translate }} : {{ sumDebit | number }}</span>
          <small></small>
          <span>{{ "ClientApp.FrontOffice.Financial.AccountingDocument.AccountsPayable" | translate }} : {{ this.sumCredit | number }}</span>
          <small></small>
          <span>{{ "ClientApp.FrontOffice.Financial.AccountingDocument.remaining" | translate }} : {{ this.remaining | number }}</span>
        </div>
      </ng-container>
      <div class="change-grid" *ngIf="currentInformation.TreasuryKind === SoftWareLicenseKind.TreasuryWeb">
        <div (click)="swipeGrid()" class="detail" [class.selectTab]="showAccountingDocument">
          <span>{{ "ClientApp.Pages.PageMenu.AccountingDocument" | translate }}</span>
        </div>
        <div (click)="swipeGrid()" class="detail" [class.selectTab]="!showAccountingDocument">
          <span>{{ "ClientApp.Pages.PageMenu.ReceiptPayment" | translate }}</span>
        </div>
        <ssg-select
          *ngIf="model.FilterDateList && model.FilterDateList?.length > 0"
          name="FilterDateList"
          [group]="formGroup"
          [dataList]="model.FilterDateList"
          [label]="'ClientApp.FrontOffice.Financial.AccountingDocument.DateFilter' | translate"
          textFieldName="Title"
          valueFieldName="Id"
          (valueChange)="valueChange($event)"
          userClass="select-sm">
        </ssg-select>
      </div>
    </div>
    <div class="form-grid" [ngClass]="{ 'grid-visible': showAccountingDocument }" [style.visibility]="showAccountingDocument ? 'visible' : 'hidden'">
      <kgrid
        *ngIf="gridColumnsAccounting && gridColumnsAccounting?.length > 0"
        [hideToolber]="true"
        [areaName]="areaName"
        [label]="label"
        [name]="'DetailLedgerList'"
        [dataList]="DetailLedgerList"
        [unSortableFilterable]="unSortableFilterable"
        [filtering]="false"
        [isEdit]="false"
        [isDelete]="false"
        pagingSize="5"
        pathPreFix="SALE"
        [paging]="false"
        [columns]="gridColumnsAccounting"
        [noAutoFitColumns]="true">
      </kgrid>
    </div>
    <div
      class="form-grid"
      [ngClass]="{ 'grid-visible': !showAccountingDocument }"
      [style.visibility]="!showAccountingDocument ? 'visible' : 'hidden'"
      *ngIf="gridColumnsTrsVoucher && gridColumnsTrsVoucher?.length > 0">
      <kgrid
        [contextMenuTrigger]="menu"
        [menuContext]="{ value: accountingDocumentSetting, visible: true, settingChanges$: settingChanges$ }"
        (menuAction)="($event)"
        [hideToolber]="true"
        [areaName]="areaName"
        [label]="'ClientApp.FrontOffice.Financial.AccountingDocument.ReceiveAndPay' | translate"
        [name]="'TrsDetailLedgerList'"
        [dataList]="TrsDetailLedgerList"
        [unSortableFilterable]="unSortableFilterable"
        [filtering]="false"
        [isMulti]="true"
        [isEdit]="false"
        [isDelete]="false"
        pagingSize="5"
        pathPreFix="SALE"
        [paging]="false"
        [columns]="gridColumnsTrsVoucher"
        [noAutoFitColumns]="true">
      </kgrid>
    </div>
  </ng-container>
</dynamic-form>
